//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'clientRecommendSelf_';

const initialState = {
	  data:[],
	  dataLoading: true,
	  dataFetchProps: {order:[['id','desc']],
		  include:[{model:'client_credit',as:'m_clientCredit',attributes:['audit_time','guarantee_type']}],

	  },
      modalVisible: false,
	  modalRecommendVisible: false,
	  modalType: 'create',
	  selectedRow: {},
	  selectedRowIndex: -1,
	  selectedRows: [],
      selectedRowKeys: [],
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,
		},
	  searchProps:{},
	filePath:'',
	modalFlag: false,

}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {

		let newData = state.data

		let {selectedRowIndex, id} = action.payload

		newData[selectedRowIndex] = action.payload.data

		return {...state, selectedRow: action.payload.data, data: newData}
	}

	case namespace+"deleteDataById": {

		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)

		return {...state, data: newData}
	}

	case namespace+"addOneRowData": {

		return {...state, data: [action.payload.data, ...state.data]}
	}

    default:
      return state;
  }
}
